import { Link, useLocation } from 'react-router-dom'
import { PbccHeroHeader, PbccAdminSidebar } from '../../components/PbccLayout.jsx'
import HustlerHero from '../../components/HustlerHero.jsx'
import { clearAdminSession } from '../PinGate.jsx'
import CLUB from '../../config/club.js'
import GGPinGate from './GGPinGate.jsx'
import GUniversalSearch from './GUniversalSearch.jsx'
import { GGC_ONLY, HUSTLER } from '../../config/siteMode.js'

const PRIMARY = CLUB.primaryColor || 'var(--ge-primary)'
const ACCENT = CLUB.accentColor || 'var(--ge-primary)'

// Derive the Back target from the current route. Hub pages (the Pro Shop Suite
// home) get NO back tab — the sidebar covers them. Detail pages go to their
// list; every other sub-page goes to the suite home. Computed here so every
// sub-page gets a consistent top-left Back tab automatically — no per-page code.
function computeBack(pathname) {
  const p = pathname.replace(/\/$/, '')
  if (p === '/admin/gg' || p === '/admin' || p === '/admin/gg-features') return null // hub — no back
  if (/^\/admin\/gg\/members\/[^/]+$/.test(p)) return { to: '/admin/gg/members', label: 'Members' } // member detail → list
  if (p === '/admin/gg/formats' || p === '/admin/gg/multi-format' || p.startsWith('/admin/gg/games')) return { to: '/admin/gg-features', label: 'Golf Game Central' } // games → G-Features hub
  return GGC_ONLY
    ? { to: '/admin/gg-features', label: 'Golf Game Central' } // members' standalone → Golf Game Central
    : { to: '/admin/gg', label: 'Pro Shop Suite' }             // staff → the suite home
}

// Shared admin chrome for every Pro Shop Suite page. Renders the standard hero
// + sidebar, the GG access-code gate, a route-derived Back tab (top-left), the
// universal search, then page content. One shell + one gate for the whole suite.
export default function GShell({ children, active = 'gg' }) {
  const { pathname } = useLocation()
  const back = computeBack(pathname)
  // Golf Hustler: a game setup/list page reads "Back to Games" (matches the mockup).
  const backLabel = HUSTLER && back && pathname.startsWith('/admin/gg/games') ? 'Back to Games' : back?.label
  const lock = () => { clearAdminSession(); location.reload() }
  return (
    <>
      <div className="pbcc-main-panel-4ball flex-1 flex flex-col min-h-0 min-w-0">
        {/* Golf Hustler: the big header/hero banner shows only on the games hub;
            sub-pages (setup, history, etc.) use the compact back link + title. */}
        {HUSTLER ? (back ? null : <HustlerHero />) : <PbccHeroHeader variant="admin" onLock={lock} onSignOut={lock} onHelp={() => {}} />}
        <div className="flex flex-1 min-h-0">
          <main className={HUSTLER
            ? 'hh-main w-full mx-auto pt-0 pb-6 space-y-5 flex flex-col flex-1 min-h-0'
            : `${GGC_ONLY ? 'max-w-7xl' : 'max-w-6xl'} w-full mx-auto p-4 sm:p-5 space-y-5 flex flex-col flex-1 min-h-0`}>
            <GGPinGate>
              {back ? (
                <div className={HUSTLER ? 'pt-5' : ''}>
                  <Link to={back.to} className="inline-flex items-center gap-1.5 text-xs font-bold px-3 py-1.5 rounded-full transition uppercase tracking-wider"
                    style={HUSTLER
                      ? { background: 'transparent', border: 'none', color: '#9CC400', paddingLeft: 0 }
                      : { background: '#fff', border: `1px solid ${ACCENT}66`, color: PRIMARY }}>
                    <span aria-hidden>←</span> {backLabel}
                  </Link>
                </div>
              ) : null}
              {/* Universal search is the STAFF Pro Shop lookup (members/products/
                  repairs/gift-cards/orders from world-readable club data). Hidden
                  on the members' standalone GGC — it's useless here (results link
                  to Pro Shop routes that don't exist) and would expose staff/member
                  Pro Shop records. Staff build (GGC_ONLY=false) keeps it as-is. */}
              {!GGC_ONLY && <div className="mb-1"><GUniversalSearch /></div>}
              {children}
            </GGPinGate>
          </main>
        </div>
      </div>
    </>
  )
}
